module.exports = __webpack_public_path__ + "img/logout.d1566f84.svg";